package one.healthium.log_symptoms.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.log_symptoms.ui.LogSymptomsScreen

@Composable
fun LogSymptomsContent(component: LogSymptomsComponent) {
    CompositionLocalProvider(
        LocalViewModelStoreOwner provides component
    ) {
        LogSymptomsScreen(component.taskId, component.backHandler, component)
    }
}